var map = {
	"./A.png": "85d0",
	"./FrP.png": "2531",
	"./H.png": "3b2c",
	"./KrF.png": "7e29",
	"./MDG.png": "ceda",
	"./R.png": "17bf",
	"./SP.png": "0f24",
	"./SV.png": "74d2",
	"./Sentrum.png": "1d72",
	"./V.png": "e00c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b553";